import { LegalDocumentPage } from "@/components/legal/LegalDocumentPage";
import { legalDocuments } from "@/content/legalDocuments";

export default function FoodAllergens() {
  return <LegalDocumentPage document={legalDocuments.allergens} />;
}